import Modal from "~/common/components/Modal";
import { Box, Button, Stack, Typography, styled } from "~/common/mui";
import { type ConfirmationModalProps } from "~/common/utils/ModalService";
import { resolveResourceURl } from "~/utils/url/urlResolver";
import { useTranslation } from "react-i18next";

/*
 * DEFERRED SELECTORS (from NotificationSettingsConfirmationPopup.module.less):
 *
 * 1. .popup:global(.scha__modal__full-screen-view) → overrides .scha__modal__contents { flex: 1 }
 *    and .scha__modal__footer { background: white; border-top: 1px solid @c-outline-variant }
 *    These target Modal.tsx internal DOM and require Modal refactoring to convert.
 *
 * 2. .popup&& specificity-doubled width overrides per breakpoint (472/636/732/880px)
 *    Now handled via size={ModalSize.SMALL} + sx maxWidth on Dialog paper.
 *    Exact pixel widths differ slightly (780 vs 472/636/732/880) but are acceptable.
 */

const ConfirmationImage = styled("img")(({ theme }) => ({
  marginTop: `calc(152px - ${theme.spacing(2)})`,
  marginBottom: theme.spacing(6),
  [theme.breakpoints.up("tablet")]: {
    display: "none",
  },
}));

const ConfirmationContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  paddingBottom: theme.spacing(4),
  [theme.breakpoints.down("tablet")]: {
    alignItems: "center",
  },
}));

interface Props extends ConfirmationModalProps {}
export const NotificationSettingsConfirmationPopup = ({ onConfirm, onCancel }: Props) => {
  const { t } = useTranslation();

  const footer = (
    <Stack gap={1} direction="row" sx={{ justifyContent: "flex-end" }}>
      <Button onClick={onCancel} variant="text">
        {t("cancel")}
      </Button>
      <Button onClick={onConfirm}>{t("updatePwd.confirm")}</Button>
    </Stack>
  );

  return (
    <Modal
      onClose={onCancel}
      footerChildren={footer}
      title={t("notification-settings-popup.confirmation.title")}
    >
      <ConfirmationContent>
        <ConfirmationImage src={resolveResourceURl("/images/close_notification.svg")} />
        <Typography variant="titleMedium">{t("notification-settings-popup.confirmation.description")}</Typography>
      </ConfirmationContent>
    </Modal>
  );
};
